export function issueLabel(
	payload: {
		issueIdentifier?: string
		issueTitle?: string
	},
	issue?: { identifier?: string | null; title?: string | null },
): string {
	const identifier = payload.issueIdentifier ?? issue?.identifier ?? undefined
	const title = payload.issueTitle ?? issue?.title ?? undefined
	return [identifier, title].filter(Boolean).join(" ") || "issue"
}
